<template>
  <div class="w-full lg:w-1/2">

    <div class="">
      <img src="https://miro.medium.com/max/4800/1*QmVUbweLwjdrr1emgX_W5w.png" style="max-width:500px;" />
    </div>

    <div class="text-base mt-8 leading-relaxed">
      As a broker, you understand the importance of referrals and we do too. 
    </div>

    <div class="text-base mt-4 leading-relaxed">
      That's why when you refer {{ getAppName }} to others, we will reward you with
      <span class="font-semibold">ONE MONTH'S FREE</span> subscription for each person that you refer, 
      if they subscribe to either Standard or Pro plan (e.g. Refer 6 people and get 6 months for free!).
      In addition, everyone you refer will receive an extra week on their free trial. Everyone wins!
    </div>

    <div class="text-base mt-4 leading-relaxed">
      All you need to do is either copy your referral link below (by clicking the Copy button below), 
      paste it into an email and ask them to to register on {{ getAppName }} or use the invitation email
      form below to send emails directly.
    </div>

    <div class="text-base mt-4">
      We keep track of the referrals and will give you a month free after they subscribe to one of the plans.
    </div>

    <div class="bg-gray-200 p-4 rounded mt-8">
      <div class="text-base font-semibold">
        Your referral link
      </div>

      <div class="mt-2 text-sm">
        Copy the following link, send them to people you know who can sign-up via the link!
      </div>

      <div class="form-line flex items-center">
        <input type="text" 
          ref="link"
          readonly="true" 
          class="input-standard"
          style="width:600px;"
          :value="link" />

        <button class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-3 ml-4 font-semibold" 
          type="button" 
          v-clipboard:copy="link"
          v-clipboard:success="onCopy">Copy!</button>
      </div>
    </div>


    <div class="text-base mt-8">
      You can also use the following invitation form to email your colleagues directly.
    </div>


    <div class="bg-gray-200 p-4 rounded mt-8">
      <div class="text-base font-semibold">Send invitations to following emails</div>
    
      <template v-for="(cc, index) in emails">
        <div class="form-line relative">
          <input type="text" class="input-standard" v-model="cc.email" />
          <a href="#" @click.prevent="removeCCEmail(index)" class="text-blue-500 hover:underline">
            <svg width="16" height="16" stroke-width="2" class="absolute text-gray-500 hover:text-red-500" stroke="currentColor" fill="none" style="top:13px;right:10px;">
              <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
            </svg>
          </a>
          <div v-if="cc.error != null" class="mt-2 text-red-600">{{ cc.error }}</div>
        </div>
      </template>

      <div class="form-line">
        <a href="#" @click.prevent="addCCEmail" class="text-sm text-blue-600 hover:underline">Add another email</a>
      </div>

      <div class="mt-8 text-base font-semibold">Referral message</div>

      <div class="form-line">
        <textarea
          class="w-full border border-gray-600 p-3 outline-none text-sm"
          style="height:150px;"
          v-model="message" />
      </div>

      <div class="button-line">
        <button 
          v-on:click="send" 
          class="text-white outline-none bg-blue-500 hover:bg-blue-600 inline-block overflow-hidden font-semibold text-sm py-3 w-32">Send</button>
      </div>
    </div>
  </div>
</template>

<script>
  import validator      from 'validator'
  import { EventBus }   from '@/shared/event-bus'

  export default {

    data () {
      return {
        loading : false,
        broker  : null,
        link    : null,
        emails: [{ email : null, error : null}],
        message : null
      }
    },

    created() {
      this.user    = _.cloneDeep(this.$store.state.user)
      this.broker  = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)
      this.link    = this.getReferralLink(this.broker)
      this.message = this.getDefaultReferralMessage(this.user, this.link)
    },

    methods : {
      addCCEmail() {
        this.emails.push({
          email : null,
          error : null
        })
      },

      removeCCEmail(index) {
        this.emails.splice(index, 1)
      },

      onCopy() {
        EventBus.$emit('notification-event', {
          'type'   : 'success',
          'message': "Link copied to your clipboard"
        })
      },

      send() {
        let valid = true

        if(this.emails != null && this.emails.length > 0) {

          // let emails = this.ccEmail.split(",")
          for(let i=0; i < this.emails.length; i++) {
            this.emails[i].error = null
            let e = null

            if(this.emails[i].email != null) {
              e = this.emails[i].email.trim()
            }

            if(e == null || e.length == 0 || !validator.isEmail(e)) {
              this.emails[i].error = "Please type in a valid email address."
              valid = false
            }
          }
        }

        if(valid) {
          this.showLoader("Sending...")
          this.apiPost({
            emails: this.emails,
            msg   : this.message,
            link  : this.link
          }, 'broker/send-referrals', (data) => {          
            this.hideLoader()
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Email sent successfully."
            })
          })
        }
      }
    },
  }
</script>